import { render, staticRenderFns } from "./GameWindow.vue?vue&type=template&id=5ff3406a&scoped=true"
import script from "./GameWindow.vue?vue&type=script&lang=js"
export * from "./GameWindow.vue?vue&type=script&lang=js"
import style0 from "./GameWindow.vue?vue&type=style&index=0&id=5ff3406a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff3406a",
  null
  
)

export default component.exports